import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

export const FeedPostsSkeleton: FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
    {Array.from({ length: 4 }).map((_, i) => (
      // oxlint-disable-next-line react/no-array-index-key
      <Box key={i} sx={{ bgcolor: 'background.paper', borderRadius: 2, p: 2.5 }}>
        {/* Author row */}
        <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box>
            <Skeleton variant="text" width={120} height={18} />
            <Skeleton variant="text" width={60} height={14} />
          </Box>
        </Box>

        {/* Post title */}
        <Skeleton variant="text" width="60%" height={22} sx={{ mb: 1 }} />

        {/* Post body lines */}
        <Skeleton variant="text" width="100%" height={16} />
        <Skeleton variant="text" width="95%" height={16} />
        <Skeleton variant="text" width="80%" height={16} />

        {/* Reactions row */}
        <Box display="flex" gap={2} mt={2}>
          <Skeleton variant="text" width={70} height={16} />
          <Skeleton variant="rectangular" width={50} height={22} sx={{ borderRadius: 11 }} />
        </Box>
      </Box>
    ))}
  </Box>
);
